import React from 'react';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';

import Popup from '../../Popup';

import styles from './styles.styl';

const ModalWrapper = ({ open, title, children, onClose = noop }) => (
  <Popup
    strictClose
    title={title}
    opened={open}
    overflowVisible
    withoutAdaptive
    onClose={onClose}
    mobileFullScreen={false}
  >
    <div className={styles.modal}>{children}</div>
  </Popup>
);

ModalWrapper.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node,
};

export default ModalWrapper;



// WEBPACK FOOTER //
// ./src/components/common/Charts/ModalWrapper/index.jsx